import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import * as CryptoJS from "crypto-js";
// import * as forge from "node-forge";
import { Observable, of } from "rxjs";
import { JSEncrypt as JSEncrypt1 } from "jsencrypt";
const JSEncrypt = require("jsencrypt");
import { tap } from "rxjs/operators";
import { PLATFORM_ID, Inject } from "@angular/core";
import { isPlatformBrowser } from "@angular/common";
@Injectable({ providedIn: "root" })
export class EncryptionDecryptionService {
  isBrowser: boolean;
  rsaAlgorithm: any;
  ivB64: string;
  ivWordArray: any[];
  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private http: HttpClient
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
    if (this.isBrowser) {
      this.rsaAlgorithm = new JSEncrypt1({ default_key_size: '2048' });
    } else {
      this.rsaAlgorithm = new JSEncrypt({ default_key_size: '2048' });
    }
  }
  // frontendPublicKey: string;
  frontendPublicKey64: string;
  // frontendPrivateKey: any;

  isHandshaked() {
    if (
      // !this._getFrontendPrivateKey() ||
      // !this._getFrontendPrivateKeyB64FromLocalStorage() ||
      // !this._getBackendPublicKey() ||
      !this._getAuthIdFromLocalStorage() ||
      !this._getPointerIdFromLocalStorage()
    ) {
      return false;
    } else return true;
  }
  public handShaking() {
    this.removeFrontendKeys();
    this.setRsaKeysToLocalStorage();
    // this._setFrontendPrivateKeyToCookies();
    // this._setFrontendPrivateKey();
    // this._setFrontendPrivateKeyBase64();
    // this._setFrontendPublicKey();
    // this._setFrontendPublicKeyBase64();
    // this._setFrontendPrivateKeyToAlgorithm();

    return this.http.post("/Account/HandShake", null).pipe(
      tap((res: any) => {
        if (res) {
          // this._setFrontendPrivateKeyB64ToLocalStorage();
          // this._setFePubKB64();
          this._setAesEncryptedByRsa(res.majorKey);
          this._setFrontendPrivateKeyB64ToRsa();
          // this._setBackendPublicKey(res.publicId);
          this._setPointerIdEncryptedByRsaToLocalStorage(res.pointerId);
          this._setAuthIdEncryptedByRsaToLocalStorage(res.authId);
        }
      })
    );
  }
  removeFrontendKeys() {
    localStorage.removeItem("pIdEnByRsa");
    localStorage.removeItem("bePubK");
    localStorage.removeItem("AIdEnByRSA");
    localStorage.removeItem("fePriKB64");
    localStorage.removeItem("MK");
    localStorage.removeItem("fePubKB64");
    // localStorage.removeItem("frontendPublicKey");
    // localStorage.removeItem("frontendPrivateKey");
  }

  isJson(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  setRsaKeysToLocalStorage() {
    this._setFrontendPrivateKeyB64ToLocalStorage();
    this._setFrontendPublicKeyB64ToLocalStorage();
  }

  // start frontend private key functions
  _setFrontendPrivateKeyB64ToLocalStorage() {
    localStorage.setItem("fePriKB64", this.rsaAlgorithm.getPrivateKeyB64());
    this._setFrontendPrivateKeyB64ToRsa()

  }
  // _setFrontendPrivateKey() {
  //   localStorage.setItem(
  //     "frontendPrivateKey",
  //     this.rsaAlgorithm.getPrivateKey()
  //   );
  // }
  // _getFrontendPrivateKey() {
  //   return localStorage.getItem("frontendPrivateKey") || null;
  // }

  _setFrontendPrivateKeyB64ToRsa() {
    this.rsaAlgorithm.setPrivateKey(
      this._getFrontendPrivateKeyB64FromLocalStorage()
    );
  }
  // _setFrontendPrivateKeyToAlgorithm() {
  //   this.rsaAlgorithm.setPrivateKey(this._getFrontendPrivateKey());
  // }

  _getFrontendPrivateKeyB64FromLocalStorage() {
    return localStorage.getItem("fePriKB64") || null;
  }
  // end frontend private key functions

  // start backend public key functions
  _setBackendPublicKeyToLocalStorage(backendPublicKey: any) {
    localStorage.setItem("bePubK", backendPublicKey);
  }
  _getBackendPublicKeyFromLocalStorage() {
    return localStorage.getItem("bePubK") || null;
  }
  // end backend public key functions

  // start pointer id  functions
  _setPointerIdEncryptedByRsaToLocalStorage(pointerID: any) {
    localStorage.setItem("pIdEnByRsa", pointerID);
  }
  _getPointerIdDecryptedByRsaFromLocalStorage() {
    this._setFrontendPrivateKeyB64ToRsa();
    var pointerIdEncrypted: any = this.rsaAlgorithm.decrypt(
      this._getPointerIdFromLocalStorage()
    );
    return pointerIdEncrypted || null;
  }
  _getPointerIdFromLocalStorage() {
    return localStorage.getItem("pIdEnByRsa") || null;
  }
  // _getPointerIdEncryptedByBackendPublicKey() {
  //   var rsa = forge.pki.publicKeyFromPem(this._getBePubKey());
  //   var PointerIdEncryptedByBackendPublicKey = window.btoa(
  //     rsa.encrypt(this._getPointerIdDecrypted)
  //   );
  //   return PointerIdEncryptedByBackendPublicKey;
  // }
  // end pointer id  functions

  // start auth id  functions
  _setAuthIdEncryptedByRsaToLocalStorage(authID: any) {
    localStorage.setItem("AIdEnByRSA", authID);
  }
  _getAuthIdDecryptedByRsaFromLocalStorage() {
    this._setFrontendPrivateKeyB64ToRsa();
    var authIdDecrypted: any = this.rsaAlgorithm.decrypt(
      localStorage.getItem("AIdEnByRSA")
    );
    return authIdDecrypted || null;
  }

  _getAuthIdFromLocalStorage() {
    return localStorage.getItem("AIdEnByRSA") || null;
  }
  // end auth id  functions

  // start frontend public key functions
  // _setFrontendPublicKey() {
  //   localStorage.setItem("frontendPublicKey", this.rsaAlgorithm.getPublicKey());
  // }
  // _getFrontendPublicKey() {
  //   return localStorage.getItem("frontendPublicKey");
  // }

  _setFrontendPublicKeyB64ToLocalStorage() {
    localStorage.setItem("fePubKB64", this.rsaAlgorithm.getPublicKeyB64());
  }
  _getFrontendPublicKeyB64FromLocalStorage() {
    return localStorage.getItem("fePubKB64") || null;
  }
  _setAesEncryptedByRsa(aesKey: string) {
    localStorage.setItem("MK", aesKey);
  }

  _getAesKeyDecryptedByRsa() {
    this._setFrontendPrivateKeyB64ToRsa();
    var aesKey: any = this.rsaAlgorithm.decrypt(localStorage.getItem("MK"));
    return aesKey || null;
  }

  encryptByAes(text: string) {
    this.generateIv();
    const encrypted = CryptoJS.AES.encrypt(
      text,
     CryptoJS.enc.Base64.parse(this._getAesKeyDecryptedByRsa()),
      {
        iv: this.ivWordArray,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );
    // const originalMessage = decrypted.toString(CryptoJS.enc.Utf8);
    return encrypted.toString();
  }
  decryptByAes(text: string, iv: string) {
    const decrypted = CryptoJS.AES.decrypt(
      text,
      CryptoJS.enc.Base64.parse(this._getAesKeyDecryptedByRsa()),
      {
        iv: this.parseIvB64ToWordArray(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    );
    return decrypted.toString(CryptoJS.enc.Utf8)

    // return decrypted;
  }
  parseIvB64ToWordArray(iv: string) {
    return CryptoJS.enc.Base64.parse(iv);
  }
  generateIv() {
    this.ivWordArray = CryptoJS.lib.WordArray.random(128 / 8);
    this.ivB64 = CryptoJS.enc.Base64.stringify(this.ivWordArray);
  }

  // end frontend public key functions

  //start encryption/decryption functions
  // encryptByBackendPublicKey(plainText: string) {
  //   var rsa = forge.pki.publicKeyFromPem(this._getBackendPublicKey());
  //   var ENTEXT = window.btoa(rsa.encrypt(plainText));
  //   return ENTEXT;
  // }

  encryptByFrontendPublicKeyB64(plainText: string) {
    this._setFrontendPrivateKeyB64ToRsa();
    return this.rsaAlgorithm.encrypt(plainText);
  }

  // decryptByFrontendPrivateKey(EnText: string) {
  //   this._setFrontendPrivateKeyToAlgorithm();
  //   return this.rsaAlgorithm.decrypt(EnText);
  // }

  decryptByFrontendPrivateKeyB64(EnText: string) {
    this._setFrontendPrivateKeyB64ToRsa();
    return this.rsaAlgorithm.decrypt(EnText);
  }
  // encryptByFrontendPublicKey(plainText) {
  //   this._setFrontendPrivateKeyToAlgorithm();
  //   return this.rsaAlgorithm.encrypt(plainText) || null;
  // }
  //end encryption/decryption functions

  // start signture functions
  generateSignture(data: string) {
    let x = data + this._getAuthIdDecryptedByRsaFromLocalStorage();
    var hashed: any = CryptoJS.SHA256(x);
    var uint8array = new TextEncoder().encode(hashed);
    var string: any = new TextDecoder().decode(uint8array);

    return string;
  }
  handle_hanshaking_signture(result: any) {
    //body comes stringified unknown bug
    if (this.isJson(result.body)) {
      result.body = JSON.parse(result.body);
    }

    //content received stringified becuase of autorounding javascript
    result.body.content = JSON.parse(result.body.content);
    var decryptedAuthId: any = this.decryptByFrontendPrivateKeyB64(
      result.body.content.authId
    );
    result.body.content = JSON.stringify(result.body.content);
    var hashed: any = CryptoJS.SHA256(result.body.content + decryptedAuthId);
    var uint8array = new TextEncoder().encode(hashed);
    var generatedSignture: any = new TextDecoder().decode(uint8array);
    result.body.content = JSON.parse(result.body.content);

    if (result.body.signature != generatedSignture) {
      throw new Error(
        "invalid reponse signture another backend played with the response !"
      );
    } else return result;
  }
  // end signture functions

  // start res/req functions
  // dividingStringToEncryptedArray(stringifiedBody: string) {
  //   var start = 0;
  //   var arrayOfEncryptedValues = [];
  //   let length = stringifiedBody.length;
  //   for (let i = 1; i <= Math.ceil(length / 70); i++) {
  //     var end: any = 70 * i;
  //     if (end <= length) {
  //       arrayOfEncryptedValues.push(
  //         this.encryptByBackendPublicKey(
  //           forge.util.encodeUtf8(stringifiedBody.slice(start, end))
  //         )
  //       );
  //     } else {
  //       let x: string = stringifiedBody.slice(start, length);
  //       arrayOfEncryptedValues.push(
  //         this.encryptByBackendPublicKey(forge.util.encodeUtf8(x))
  //       );
  //     }

  //     start = end;
  //   }

  //   return JSON.stringify(arrayOfEncryptedValues);
  // }

  // gatheringEncryptedArray(arrayEncrypted: []) {
  //   var result: any = "";
  //   for (let i = 0; i < arrayEncrypted.length; i++) {
  //     result = result.concat(
  //       this.decryptByFrontendPrivateKey(arrayEncrypted[i])
  //     );
  //   }
  //   return result;
  // }
  // end response/requset functions
}
